<template>
    <div class="view view__course_show">
        <course-show/>
    </div>
</template>

<script>
import CourseShow from '@/components/ebs/courses/show/CourseShow'
import { User } from '@/User'

export default {
  name: 'view-course-show',
  components: { CourseShow },
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    },
    routeParamsEnrolmentId () {
      return this.$route.params.enrolmentId
    }
  },
  watch: {
    routeParamsEnrolmentId (from, to) {
      if (from && to && (from !== to)) {
        this.getCatalogItem()
      }
    }
  },
  methods: {
    getCatalogItem () {
      const courseCatalogId = this.$route.params.courseCatalogId
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('ebsCatalogItemGet', courseCatalogId).then(response => {
        const routeParamsEnrolmentId = this.$route.params.enrolmentId
        const latestEnrolment = response.latestEnrolment
        const latestEnrolmentId = latestEnrolment ? latestEnrolment.id : undefined
        const latestEnrolmentState = latestEnrolment ? latestEnrolment.state : undefined
        let actionsArr = []
        let actionsCounter = 0

        this.getCourseVersion().then(() => {
          actionsArr.push({
            func: () => this.getCatalogItemUrls(courseCatalogId)
          })
          actionsArr.push({
            func: () => this.getCatalogItemFiles(courseCatalogId)
          })
          actionsArr.push({
            func: () => this.getCatalogItemLearnerEnrolments(courseCatalogId)
          })

          if (routeParamsEnrolmentId || (latestEnrolmentId && latestEnrolmentState !== 'cancelled')) {
            actionsArr.push({
              func: () => this.getCourseHistory(routeParamsEnrolmentId || latestEnrolmentId)
            })
            actionsArr.push({
              func: () => this.getEnrolment(routeParamsEnrolmentId || latestEnrolmentId)
            })
            actionsArr.push({
              func: () => this.getCourseFeedback()
            })
          } else {
            actionsArr.push({
              func: () => this.getEnrolmentValidate()
            })
          }

          for (let action of actionsArr) {
            action.func().finally(() => {
              actionsCounter++

              if (actionsCounter === actionsArr.length) {
                this.$eventBus.$emit('stop-loading')
              }
            })
          }
        })
      })
    },
    getCourseVersion () {
      return new Promise((resolve, reject) => {
        const courseId = this.$route.params.courseId
        const versionId = this.$route.params.versionId
        const courseCatalogId = this.$route.params.courseCatalogId

        this.$store.dispatch('ebsCourseGetVersion', { courseId, versionId, courseCatalogId, extendModules: true }).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCourseHistory (data) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('ebsCourseGetHistory', data).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCatalogItemLearnerEnrolments (data) {
      this.$store.dispatch('ebsCatalogItemLearnerEnrolmentsClear')
      return new Promise((resolve, reject) => {
        this.$store.dispatch('ebsCatalogItemLearnerEnrolmentsGet', data).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getCourse () {
      const courseId = this.$route.params.id

      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('ebsCourseGet', { courseId, extendModules: true }).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    },
    getEnrolment (data) {
      return this.$store.dispatch('ebsEnrolmentGet', data)
    },
    getCatalogItemFiles (data) {
      return this.$store.dispatch('ebsCatalogItemGetFiles', data)
    },
    getCatalogItemUrls (data) {
      return this.$store.dispatch('ebsCatalogItemGetUrls', data)
    },
    getEnrolmentValidate () {
      return this.$store.dispatch('ebsEnrolmentValidate')
    },
    getCourseFeedback (data) {
      return this.$store.dispatch('ebsCourseFeedbackGet')
    },
    handleGetData () {
      if (this.routeName === 'ebs-course-show') {
        this.getCourse()
      } else {
        this.getCatalogItem()
      }
    }
  },
  created () {
    this.$store.dispatch('ebsCertificateClear')
    this.$store.dispatch('ebsEnrolmentClear')
    this.$store.dispatch('ebsCourseClear')
    this.$store.dispatch('ebsCatalogItemClear')
    this.$eventBus.$on('perform-get-course', this.handleGetData)
    this.$eventBus.$on('ebs-course-get', () => this.$eventBus.$emit('stop-loading'))
    this.$eventBus.$on('ebs-course-get-version', () => this.$eventBus.$emit('stop-loading'))
    this.handleGetData()
  },
  beforeDestroy () {
    this.$eventBus.$off('perform-get-course')
    this.$eventBus.$off('ebs-course-get')
    this.$eventBus.$off('ebs-course-get-version')
  }
}
</script>
